import { getAccessTokenSilently } from "utils/functions";
import { Avatar } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { AvatarGroup, Pagination } from "@material-ui/lab";
import Tooltip from "@mui/material/Tooltip";
import sortImg from "assets/icons/sort-able-svg.svg";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import RightDrawer from "components/drawer";
import MyFilterButton from "components/MyFilterButton";
import NewDialog from "components/NewDialog/Dialog";
import { formatDate } from "helper/dateFormat";
import { SubHeader } from "layout/SubHeader";
import AuthService from "Lib/API/Auth";
import * as _ from "lodash";
import moment from "moment";
import AddYahrzeit from "pages/Yahrzeit/NewYahrzeit";
import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { DateFormetContext } from "../../app/App.js";
import Action from "../../components/ActionPopOver";
import MyTable from "../../components/Table";
import { withUserExist } from "../CustomHooks";
import AddMourner from "./AddMourner/AddMourner.jsx";
import "./style.scss";
import YahrzietDrawer from "./YahrzietDrawer";
import { Fonts, FontFamilies, FontWeights, FontColors } from "theme/fontConfig";

const initialFilter = {};
const Yahrzeit = () => {
  const { disableEditingOnMemberPortal, orgName } = localStorage.getItem(
    "organization"
  )
    ? JSON.parse(localStorage.getItem("organization"))
    : {};

  const [loading, setLoading] = useState(false);
  const dateFormet = React.useContext(DateFormetContext);
  const [filters, setFilters] = useState(initialFilter);
  const [list, setList] = useState([]);
  const history = useHistory();
  const [openModal, setOpenModal] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [deceasedId, setDeceasedId] = React.useState("");
  const [total, setTotal] = useState();
  const [refresh, setRefresh] = React.useState("");
  const [openDiscardChanges, setOpenDiscardChanges] = React.useState(false);
  const [sortBy, setSortBy] = useState("");
  const [touched, setTouched] = React.useState({});
  const [show, setShow] = useState("");
  const [csvData, setExportData] = React.useState([]);
  const [count, setCount] = useState();
  const [loadingYahirzeit, setLoadingYahirzeit] = useState(false);
  console.log(count, "setCount");
  const [page, setPage] = useState(0);
  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [openAddMournerModal, setOpenAddMournerModal] = useState(false);
  const [openAddMournerSource, setOpenAddMournerSource] = useState("table");
  const [mournersList, setMournersList] = useState([]);
  const [confirmClose, setConfirmClose] = useState(false);
  const [addMournerSuccess, setAddMournerSuccess] = useState(false);
  const [selectedMourner, setSelectedMourner] = useState(null);
  const [manageMournerType, setManageMournerType] = useState("create");

  const isMobile = useMediaQuery("(max-width:600px)");

  const enableLoading = (value) => {
    setLoading(value);
  };
  const handleClose = () => {
    if (_.isEmpty(touched)) setOpenModal(false);
    else setOpenDiscardChanges(true);
  };

  const handleDelete = async () => {
    setOpenModal(false);
    const token = await getAccessTokenSilently();
    await AuthService.removeDeceased({ deceasedID: deceasedId }, token)
      .then((res) => {
        if (res) {
          setOpen(false);
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        setOpen(false);
        toastr.error("Error", err?.data?.message);
      });
  };

  const getFilterdDeceased = async () => {
    const token = await getAccessTokenSilently();
    AuthService.getFilterdDeceased(page + 1, 30, filters, sortBy, token)
      .then((res) => {
        console.log(page, "pagepage");
          const result = (res?.deceaseds ?? []).map((item) => {
            item.id = item._id;
            return item;
          });
          setTotal(res.total);
          setList(result);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toastr.error("Error", err?.data?.message);
      });
  };

  console.log(list, "resultresult");

  useEffect(() => {
    getFilterdDeceased();
  }, [page, refresh, filters, sortBy]);

  const text_truncate = (str, length, ending) => {
    if (length == null) {
      length = 100;
    }
    if (ending == null) {
      ending = "...";
    }
    if (str.replaceAll("\\s", "").length >= length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  };

  const columns_to_export = [
    {
      id: "name",
      displayName: "NAME OF DECEASED",
      headerName: "NAME OF DECEASED",
      field: "name",
      flex: 1,
    },
    {
      id: "eng_date",
      displayName: "DATE OF DEATH ",
      headerName: "DATE OF DEATH ",
      field: "eng_date",
      flex: 1,
    },
    {
      id: "hebrew_date",
      displayName: "DATE OF DEATH (HEBREW)",
      headerName: "DATE OF DEATH (HEBREW)",
      field: "hebrew_date",
      flex: 1,
    },
    {
      id: "eng_mourner",
      displayName: "OBSERVERS",
      headerName: "OBSERVERS",
      field: "eng_mourner",
      flex: 1,
    },
    {
      id: "relationship",
      displayName: "RELATIONSHIP",
      headerName: "RELATIONSHIP",
      field: "relationship",
      flex: 1,
    },

    {
      id: "hebrew_mourner_english_date",
      displayName: "OBSERVERS (ENGLISH DATE)",
      headerName: "OBSERVERS (ENGLISH DATE)",
      field: "hebrew_mourner",
      minWidth: 50,
    },
    {
      id: "hebrew_mourner_hebrew_date",
      displayName: "OBSERVERS (HEBREW DATE)",
      headerName: "OBSERVERS (HEBREW DATE)",
      field: "hebrew_mourner",
      flex: 1,
    },
    {
      id: "has_plaque",
      displayName: "Has Plaque",
      headerName: "Has Plaque",
      field: "has_plaque",
      flex: 1,
    },
    {
      id: "yhartzeit_number",
      displayName: "YAHRTZEIT NUMBER",
      headerName: "YAHRTZEIT NUMBER",
      field: "yhartzeit_number",
      flex: 1,
    },
    {
      id: "mobile_phone",
      displayName: "MOBILE PHONE",
      headerName: "MOBILE PHONE",
      field: "mobile_phone",
      flex: 1,
    },
    {
      id: "home_phone",
      displayName: "HOME PHONE",
      headerName: "HOME PHONE",
      field: "home_phone",
      flex: 1,
    },
    {
      id: "email",
      displayName: "EMAIL",
      headerName: "EMAIL",
      field: "email",
      flex: 1,
    },
    {
      id: "address",
      displayName: "ADDRESS",
      headerName: "ADDRESS",
      field: "address",
      flex: 1,
    },
    {
      id: "city",
      displayName: "CITY",
      headerName: "CITY",
      field: "city",
      flex: 1,
    },
    {
      id: "state",
      displayName: "STATE",
      headerName: "STATE",
      field: "state",
      flex: 1,
    },
    {
      id: "zip",
      displayName: "ZIP CODE",
      headerName: "ZIP CODE",
      field: "zip",
      flex: 1,
    },

    {
      id: "type",
      displayName: "TYPE",
      headerName: "TYPE",
      field: "type",
      flex: 1,
    },
    {
      id: "doesnt_have_mourner",
      displayName: "HAVE MOURNERS",
      headerName: "HAVE MOURNERS",
      field: "doesnt_have_mourner",
      flex: 1,
    },
  ];
  const columns = [
    {
      field: "firstName",

      resizable: true,
      headerName: (
        <div
          onClick={() => {
            setFilters((prev) => ({
              sort: {
                firstName: prev?.sort?.firstName == 1 ? -1 : 1,
              },
            }));
          }}
        >
          DECEASED FIRST NAME{" "}
          <img src={sortImg} style={{ marginLeft: "5px" }} />
        </div>
      ),
      minWidth: 210,
      maxWidth: 210,
      sortable: false,
      headerClassName: "yahrziet-name-table view-table-margin pointer",
      renderCell: (data) => {
        return (
          <div className="user-cotainer" title={data?.row?.firstName || "-"}>
            <div className="name-container d-flex align-items-center">
              <Avatar
                className="avatar"
                style={{
                  height: "50px",
                  borderRadius: "6px",
                  width: "50px",
                }}
                alt={`yahrziet`}
              >
                <div className="name">
                  {`${data?.row?.firstName[0]}`.toUpperCase()}
                </div>
              </Avatar>
              <p className="yahrzeit__first-name table-body-data">
                {text_truncate(data?.row?.firstName, 15) || "-"}
              </p>
            </div>
          </div>
        );
      },
    },
    {
      field: "lastName",
      headerName: (
        <div
          onClick={() => {
            setFilters((prev) => ({
              ...prev,
              sort: {
                lastName: prev?.sort?.lastName == 1 ? -1 : 1,
              },
            }));
          }}
        >
          DECEASED LAST NAME <img src={sortImg} style={{ marginLeft: "5px" }} />
        </div>
      ),
      minWidth: 200,
      headerClassName: "yahrziet-name-table view-table-margin pointer",
      sortable: false,
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home ml-0 -head pl-0" title={data?.row?.lastName || "-"}>
            <div className=" flex-row-reverse">
              <p
                className="id-container w-100 table-field-hover-data text-left table-body-data"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  margin: 0,
                }}
              >
                {text_truncate(data?.row?.lastName, 15) || "-"}
              </p>
            </div>
          </div>
        );
      },
    },
    {
      field: "date_of_death",
      resizable: true,
      headerName: (
        <div
          onClick={() => {
            setFilters((prev) => ({
              sort: {
                date_of_death: prev?.sort?.date_of_death == 1 ? -1 : 1,
              },
            }));
          }}
        >
          DATE OF DEATH <img src={sortImg} style={{ marginLeft: "5px" }} />
        </div>
      ),
      sortable: false,
      minWidth: 150,
      headerClassName: "pointer",
      renderCell: (data) => (
        <div className="table-body-data">
          {data?.row?.date_of_death
            ? formatDate({
                date: data?.row?.date_of_death,
                formatType: "defaultWithUTC",
              })
            : "-"}
        </div>
      ),
    },
    {
      field: "eng-mourners",
      resizable: true,
      headerName: "ENGLISH MOURNER",
      minWidth: 200,
      sortable: false,
      renderCell: (data) => (
        <div className="table-body-data">
          <div className="avatar-container my-0 mx-5">
            <AvatarGroup max={4}>
              {data?.row?.mourners_list?.map((mourner, index) => {
                if (!mourner.observance || mourner.observance === "english")
                  return (
                    <div title={mourner?.member_id?.first_name}>
                      <Avatar
                        key={index}
                        alt={mourner?.member_id?.first_name}
                        src={mourner?.member_id?.profile_img}
                      >
                        {mourner?.member_id?.first_name &&
                          mourner?.member_id?.last_name &&
                          (
                            mourner?.member_id.first_name[0] +
                            mourner?.member_id.last_name[0]
                          ).toUpperCase()}
                      </Avatar>
                    </div>
                  );
              })}
            </AvatarGroup>
          </div>
        </div>
      ),
    },
    {
      field: "hebrew_date",
      headerName: "HEBREW DEATH DATE",
      minWidth: 180,
      headerClassName: "yahrziet-hebrewdate-head",
      sortable: false,
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home pl-0 w-100 ml-0 justify-content-center table-body-data">
            <div>
              {data?.row?.hebrew_date_of_death
                ? data?.row?.hebrew_date_of_death
                : "-"}
            </div>
          </div>
        );
      },
    },
    {
      field: "heb-mourners",
      resizable: true,
      headerName: "HEBREW MOURNER",
      minWidth: 150,
      sortable: false,
      renderCell: (data) => (
        <div className="w-100">
          <div className="avatar-container my-0 mx-5">
            <AvatarGroup max={4}>
              {data?.row?.mourners_list?.map((mourner, index) => {
                if (mourner.observance === "hebrew")
                  return (
                    <div
                      title={
                        mourner?.member_id?.first_name
                          ? `${mourner?.member_id?.first_name} ${mourner?.member_id?.last_name}`
                          : "Guest"
                      }
                    >
                      <Avatar
                        key={index}
                        alt={mourner?.member_id?.first_name}
                        src={mourner?.member_id?.profile_img}
                      >
                        {mourner?.member_id?.first_name &&
                          mourner?.member_id?.last_name &&
                          (
                            mourner?.member_id.first_name[0] +
                            mourner?.member_id.last_name[0]
                          ).toUpperCase()}
                      </Avatar>
                    </div>
                  );
              })}
            </AvatarGroup>
          </div>
        </div>
      ),
    },
    {
      field: "next_english_yhartzeit",
      resizable: true,
      headerName: "NEXT ENGLISH YAHRZEIT",
      sortable: false,
      minWidth: 200,
      renderCell: (data) => (
        <div className="table-body-data">
          {data?.row?.next_english_yhartzeit
            ? formatDate({ date: data.row.next_english_yhartzeit, formatType: "defaultWithUTC" })
            : "-"}
        </div>
      ),
    },
    {
      field: "next_hebrew_yhartzeit",
      resizable: true,
      headerName: "NEXT HEBREW YAHRZEIT",
      sortable: false,
      minWidth: 200,
      renderCell: (data) => (
        <div className="table-body-data">
          {data?.row?.next_hebrew_yhartzeit
            ? formatDate({ date: data.row.next_hebrew_yhartzeit, formatType: "defaultWithUTC" })
            : "-"}
        </div>
      ),
    },
    {
      field: "action",
      resizable: true,
      headerName: `${" "}`,
      sortable: false,
      minWidth: 10,
      renderCell: (data) => {
        return (
          <div style={{ cursor: "pointer", paddingRight: "0px" }}>
            <Action
              style={{ color: FontColors.Slate4D5565, width: "16px" }}
              onEditClick={() => setOpenModal(true)}
              disabledOnEditClick={disableEditingOnMemberPortal}
              disabledOnDeleteClick={disableEditingOnMemberPortal}
              disabledOnEditClickTooltip={`To edit a Yahrzeit, please contact ${orgName}`}
              disabledOnDeleteClickTooltip={`To delete a Yahrzeit, please contact ${orgName}`}
              onDeleteClick={() => {
                setOpen(true);
              }}
            />
          </div>
        );
      },
    },
  ];
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const getRows = () => {
    const arr = [];

    if (csvData) {
      csvData.map((item) => {
        const d = {
          name: arr
            ?.map((item) => {
              return item?.name;
            })
            .includes(item?.name)
            ? ""
            : item?.name,
          eng_date: item?.date_of_death
            ? moment(item?.date_of_death).format(dateFormet)
            : "",
          hebrew_date: item?.hebrew_date_of_death,
          eng_mourner: item?.mourners_list?.member_id?.first_name,
          relationship: item?.mourners_list?.relation,
          hebrew_mourner_english_date:
            item?.mourners_list?.observance == "english"
              ? item?.date_of_death
                ? moment(item?.date_of_death).format(dateFormet)
                : ""
              : "",
          hebrew_mourner_hebrew_date:
            item?.mourners_list?.observance == "hebrew"
              ? item?.date_of_death
                ? item?.hebrew_date_of_death
                : ""
              : "",
          has_plaque: item?.has_plaque ? item?.has_plaque : "No",
          yhartzeit_number:
            item?.date_of_death !== undefined || null
              ? new Date().getFullYear() -
                new Date(item?.date_of_death).getFullYear()
              : "",

          mobile_phone: item?.mourners_list?.member_id?.mobile_number,
          home_phone: item?.mourners_list?.member_id?.home_phone,
          email: item?.mourners_list?.member_id?.email_address,
          address: item?.mourners_list?.member_id?.location?.formattedAddress?.replace(
            /,/g,
            " "
          ),
          city: item?.mourners_list?.member_id?.city,
          state: item?.mourners_list?.member_id?.state,
          zip: item?.mourners_list?.member_id?.zip_code,
          type: item?.mourners_list?.member_id?.account_type,
          have_mourners: item?.doesnt_have_mourner,
        };
        arr.push(d);
      });
    }
    return arr;
  };

  const getExportData = async () => {
    const token = await getAccessTokenSilently();
    AuthService.getExportDeceased(token)
      .then((res) => {
        setExportData(res?.deceaseds);
        console.log(res?.deceaseds, "res?.deceaseds");
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  React.useEffect(() => {
    getExportData();
  }, [page, refresh]);

  const openAddMournerModalHandler = (
    mourners,
    type = "create",
    selectedMourner
  ) => {
    setOpenAddMournerModal(true);
    setOpenAddMournerSource("drawer");
    const filteredMourner = mourners.map((item) => {
      return {
        ...item,
        memberId: item?._id,
      };
    });
    setMournersList(filteredMourner);
    setSelectedMourner(selectedMourner);
    setManageMournerType(type);
  };

  const closeOpenAddMournerModalHandler = () => {
    setOpenAddMournerModal(false);
    setOpenAddMournerSource("table");
    setMournersList([]);
    setSelectedMourner(null);
    setManageMournerType("create");
  };

  const closeModal = () => {
    setConfirmClose(true);
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setIsOpenMergePopUp(false);
  };

  return (
    <>
      <div className="w-100 all-Yahrzeit">
        <div className="m-0 w-100 h-100 ">
          <div className="filteration" style={{ marginBottom: 12 }}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="allTime">
                <MyFilterButton
                  title="All time"
                  type="Date"
                  items={[
                    { label: "This year", value: "year" },
                    { label: "This month", value: "month" },
                    { label: "This week", value: "week" },
                    { label: "All time", value: "all" },
                  ]}
                  onChange={setSortBy}
                />
              </div>
              <Tooltip
                title={`To add a Yahrzeit, please contact ${orgName}`}
                disableHoverListener={!disableEditingOnMemberPortal}
              >
                <Button
                  variant="primary"
                  onClick={() => {
                    if (disableEditingOnMemberPortal) return;
                    setIsOpenMergePopUp(true);
                  }}
                  disabled={disableEditingOnMemberPortal}
                >
                  <span>Add New Yahrzeit</span>
                </Button>
              </Tooltip>
            </div>
          </div>
          <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", padding: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {loading ? (
                <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
                  <span>Loading...</span>
                </div>
              ) : !list?.length ? (
                <div style={{ textAlign: "center", padding: "40px 0", color: FontColors.Slate64748B, fontFamily: FontFamilies.General }}>
                  No records found
                </div>
              ) : list.map((row) => {
                const fullName = `${row.firstName || ""} ${row.lastName || ""}`.trim() || "-";
                const initials = fullName !== "-"
                  ? fullName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
                  : "?";
                const nextDate = row.next_english_yhartzeit || row.next_hebrew_yhartzeit;
                const daysSinceDeath = row.date_of_death
                  ? Math.floor((new Date() - new Date(row.date_of_death)) / (1000 * 60 * 60 * 24))
                  : null;
                const countdownLabel = daysSinceDeath === null ? null
                  : daysSinceDeath < 365
                    ? { value: daysSinceDeath, unit: "days" }
                    : { value: Math.floor(daysSinceDeath / 365), unit: "yrs" };
                return (
                  <div
                    key={row._id}
                    onClick={() => { setDeceasedId(row.id); setOpenModal(true); }}
                    style={{ borderRadius: 14, border: "1px solid #E2E8F0", overflow: "hidden", cursor: "pointer", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", transition: "box-shadow 0.18s ease, transform 0.18s ease", position: "relative", zIndex: 0 }}
                    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
                  >
                    {/* ── Header ── */}
                    <div style={{ background: "linear-gradient(135deg, #2555EF 0%, #1A3DB5 100%)", padding: "14px 16px", display: "flex", alignItems: "center", gap: 12, position: "relative", overflow: "hidden" }}>
                      <div style={{ position: "absolute", right: -24, top: -24, width: 90, height: 90, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
                      <div style={{ position: "absolute", right: 40, bottom: -30, width: 60, height: 60, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
                      {/* Initials avatar */}
                      <div style={{ width: 42, height: 42, borderRadius: "50%", background: "rgba(255,255,255,0.15)", border: "2px solid rgba(255,255,255,0.5)", display: "flex", alignItems: "center", justifyContent: "center", ...Fonts.GeneralSubHeaderFont, color: FontColors.White, flexShrink: 0, position: "relative" }}>
                        {initials}
                      </div>
                      {/* Name + Hebrew name + date of death */}
                      <div style={{ flex: 1, minWidth: 0, position: "relative" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          <span style={{ fontSize: Fonts.GeneralBodyFont.fontSize }}>🕯️</span>
                          <span style={{ ...Fonts.GeneralSubHeaderFont, color: FontColors.White, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{fullName}</span>
                        </div>
                        {row.hebrew_name_of_Death && (
                          <div style={{ fontFamily: Fonts.GeneralCaptionFont.fontFamily, fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.WhiteAlpha75, marginTop: 2 }}>
                            {row.hebrew_name_of_Death}
                          </div>
                        )}
                        {row.date_of_death && (
                          <div style={{ fontFamily: Fonts.GeneralCaptionFont.fontFamily, fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.WhiteAlpha45, marginTop: 2 }}>
                            {formatDate({ date: row.date_of_death, formatType: "defaultWithUTC" })}
                          </div>
                        )}
                      </div>
                      {/* Days/Years badge */}
                      {countdownLabel !== null && (
                        <div style={{ background: "#ffffff", borderRadius: 10, padding: "5px 10px", flexShrink: 0, textAlign: "center", position: "relative" }}>
                          <div style={{ ...Fonts.GeneralSmallHeaderFont, color: FontColors.Blue2555EF, lineHeight: 1 }}>{countdownLabel.value}</div>
                          <div style={{ fontFamily: Fonts.GeneralTinyFont.fontFamily, fontSize: Fonts.GeneralTinyFont.fontSize, color: FontColors.Blue2555EF, marginTop: 2, textTransform: "uppercase", letterSpacing: "0.05em" }}>{countdownLabel.unit}</div>
                        </div>
                      )}
                    </div>

                    {/* ── Accent line ── */}
                    <div style={{ height: 3, background: "linear-gradient(90deg, #2555EF, #7B9FFF)" }} />

                    {/* ── Date fields ── */}
                    <div style={{ background: "#ffffff", padding: "12px 16px", display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "1fr 1fr 1fr", gap: "8px 16px" }}>
                      {row.hebrew_date_of_death && (
                        <div>
                          <div style={{ fontFamily: Fonts.GeneralTinyFont.fontFamily, fontSize: Fonts.GeneralTinyFont.fontSize, color: FontColors.Slate94A3B8, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>Hebrew Date</div>
                          <div style={{ ...Fonts.GeneralSmallLabelFont, color: FontColors.Slate0F172A }}>{row.hebrew_date_of_death}</div>
                        </div>
                      )}
                      {row.next_english_yhartzeit && (
                        <div>
                          <div style={{ fontFamily: Fonts.GeneralTinyFont.fontFamily, fontSize: Fonts.GeneralTinyFont.fontSize, color: FontColors.Slate94A3B8, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>Next English</div>
                          <div style={{ ...Fonts.GeneralSmallLabelFont, color: FontColors.Slate0F172A }}>{formatDate({ date: row.next_english_yhartzeit, formatType: "defaultWithUTC" })}</div>
                        </div>
                      )}
                      {row.next_hebrew_yhartzeit && (
                        <div>
                          <div style={{ fontFamily: Fonts.GeneralTinyFont.fontFamily, fontSize: Fonts.GeneralTinyFont.fontSize, color: FontColors.Slate94A3B8, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>Next Hebrew</div>
                          <div style={{ ...Fonts.GeneralSmallLabelFont, color: FontColors.Slate0F172A }}>{formatDate({ date: row.next_hebrew_yhartzeit, formatType: "defaultWithUTC" })}</div>
                        </div>
                      )}
                    </div>

                    {/* ── Mourners ── */}
                    {row.mourners_list?.length > 0 && (
                      <div style={{ background: "#F8FAFC", borderTop: "1px solid #F1F5F9", padding: "10px 16px" }}>
                        <div style={{ fontFamily: Fonts.GeneralTinyFont.fontFamily, fontSize: Fonts.GeneralTinyFont.fontSize, color: FontColors.Slate94A3B8, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>Mourners</div>
                        {row.mourners_list.map((mourner, idx) => {
                          const mName = mourner?.member_id
                            ? `${mourner.member_id.first_name || ""} ${mourner.member_id.last_name || ""}`.trim()
                            : "Guest";
                          const mInitials = mName !== "Guest"
                            ? mName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
                            : "G";
                          const isHebrew = mourner.observance !== "english";
                          const nextObservanceYhartzeit = isHebrew
                            ? row.next_hebrew_yhartzeit
                            : row.next_english_yhartzeit;
                          const nextObservanceFormatted = nextObservanceYhartzeit
                            ? formatDate({ date: nextObservanceYhartzeit, formatType: "defaultWithUTC" })
                            : null;
                          return (
                            <div key={idx} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: idx < row.mourners_list.length - 1 ? 6 : 0 }}>
                              <div style={{ width: 26, height: 26, borderRadius: "50%", background: "#EEF2FF", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: Fonts.GeneralTinyFont.fontFamily, fontWeight: FontWeights.SemiBold, fontSize: Fonts.GeneralTinyFont.fontSize, color: FontColors.Blue2555EF, flexShrink: 0 }}>
                                {mInitials}
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                  <span style={{ fontFamily: Fonts.GeneralCaptionFont.fontFamily, fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate0F172A, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{mName}</span>
                                  {mourner.relation && (
                                    <span style={{ fontFamily: Fonts.GeneralCaptionFont.fontFamily, fontSize: Fonts.GeneralCaptionFont.fontSize, color: FontColors.Slate94A3B8, flexShrink: 0 }}>· {mourner.relation}</span>
                                  )}
                                </div>
                                {nextObservanceFormatted && (
                                  <div style={{ fontFamily: Fonts.GeneralCaptionFont.fontFamily, fontSize: Fonts.GeneralCaptionFont.fontSize, color: isHebrew ? "#EA580C" : "#2555EF", marginTop: 2 }}>
                                    Next {isHebrew ? "Hebrew" : "English"} Yahrzeit on {nextObservanceFormatted}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
              <div className="pagination-custom" style={{ marginTop: 8 }}>
                <Pagination
                  count={Math.ceil(total / 30)}
                  color="primary"
                  variant="outlined"
                  onChange={(event, value) => setPage(value - 1)}
                />
              </div>
            </div>
            <RightDrawer open={openModal} onClose={handleClose}>
              <YahrzietDrawer
                open={openDiscardChanges}
                setOpen={setOpenDiscardChanges}
                setOpenAlert={setOpen}
                setTouched={setTouched}
                setOpenDrawer={setOpenModal}
                deceasedId={deceasedId}
                refresh={refresh}
                setRefresh={setRefresh}
                isEdit={"true"}
                disableEditing={disableEditingOnMemberPortal}
                orgName={orgName}
                openAddMournerModal={openAddMournerModalHandler}
                addMournerSuccess={addMournerSuccess}
                setAddMournerSuccess={setAddMournerSuccess}
              />
            </RightDrawer>
          </div>
        </div>
        <AlertDialog
          open={open}
          handleClose={() => setOpen(false)}
          onDecline={() => {
            setOpen(false);
          }}
          onAccept={handleDelete}
          content={
            <div className="alert-message-popup">
              <p className="alert-icon">{/* <DeleteForeverIcon /> */}</p>
              <div>
                <p>Delete Item</p>
                <p className="alert-message">
                  Are you sure you want to Delete this item?
                </p>
              </div>
            </div>
          }
        />

        <div className="d-none">
          <table ref={componentRef} style={{ padding: 10, margin: 10 }}>
            <thead>
              {columns_to_export?.map((column, index) => (
                <th
                  style={{ border: "1px solid", textAlign: "center" }}
                  key={index}
                >
                  {column?.headerName}
                </th>
              ))}
            </thead>
            <tbody>
              {getRows()?.map((item, index) => {
                const d = {
                  name: item?.name,
                  eng_date: item?.eng_dateh
                    ? moment(item?.eng_date).format(dateFormet)
                    : "",
                  hebrew_date: item?.hebrew_date,
                  eng_mourner: item?.eng_mourner ? item?.eng_mourner : "",
                  relationship: item?.relationship ? item?.relationship : "-",
                  hebrew_mourner_english_date: item?.hebrew_mourner_english_date
                    ? moment(item?.hebrew_mourner_english_date).format(
                        dateFormet
                      )
                    : "-",
                  hebrew_mourner_hebrew_date: item?.hebrew_mourner_hebrew_date
                    ? moment(item?.hebrew_mourner_hebrew_date).format(
                        dateFormet
                      )
                    : "-",
                  has_plaque: item?.has_plaque ? item?.has_plaque : "No",
                  yhartzeit_number: item?.yhartzeit_number
                    ? item?.yhartzeit_number
                    : "-",
                  mobile_phone: item?.mobile_phone ? item?.mobile_phone : "-",
                  home_phone: item?.home_phone ? item?.home_phone : "-",
                  email: item?.email ? item?.email : "-",
                  address: item?.address ? item?.address : "-",
                  city: item?.city ? item?.city : "-",
                  state: item?.state ? item?.state : "-",
                  zip: item?.zip ? item?.zip : "-",
                  type: item?.type ? item?.type : "-",
                  doesnt_have_mourner: item?.doesnt_have_mourner
                    ? item?.doesnt_have_mourner
                    : "-",
                };

                return (
                  <tr key={index}>
                    {Object.values(d)?.map((objectValue, index) => (
                      <td
                        style={{ border: "1px solid", padding: 5 }}
                        key={index}
                      >
                        {objectValue}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <NewDialog
          isOpen={isOpenMergePopUp}
          handleClose={() => {
            setIsOpenMergePopUp(!isOpenMergePopUp);
          }}
          loading={loadingYahirzeit}
          title={"New Yahrzeit"}
          sx={{
            "& .MuiDialog-paperWidthSm": {
              minWidth: { xs: "95vw", sm: "997px" },
              maxWidth: { xs: "95vw", sm: "none" },
              width: { xs: "95vw", sm: "auto" },
              height: "97%",
              margin: { xs: "8px", sm: "32px" },
              overflowY: "auto",
            },
          }}
          content={
            <div className="dialog-wrapper">
              <AddYahrzeit
                setIsOpenMergePopUp={setIsOpenMergePopUp}
                isOpenMergePopUp={isOpenMergePopUp}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            </div>
          }
          contentStyle={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
            overflowY: "auto",
          }}
          buttonStyle={{ justifyContent: "right" }}
        ></NewDialog>
        <Dialog
          open={openAddMournerModal}
          onClose={closeOpenAddMournerModalHandler}
          PaperProps={{
            style: {
              width: "min(450px, 95vw)",
              height: "590px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <AddMourner
            deceasedId={deceasedId}
            onAddSuccess={() => {
              if (openAddMournerSource === "drawer") {
                setAddMournerSuccess(true);
                setOpenAddMournerModal(false);
                setRefresh(!refresh);
              }
              setOpenAddMournerModal(false);
            }}
            closeModal={closeOpenAddMournerModalHandler}
            selectedMourners={mournersList || []}
            selectedMourner={selectedMourner}
            type={manageMournerType}
          />
        </Dialog>
        <AlertDialog
          open={confirmClose}
          handleClose={() => setConfirmClose(false)}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </>
  );
};
export default withUserExist(Yahrzeit);
